import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

export interface SearchResult {
  label: string;
  description: string;
  icon: string;
  route: string;
  category: string;
}

export interface PatientSearchResult {
  _id: string;
  firstName: string;
  lastName: string;
  patientNumber?: string;
  email?: string;
  phone?: string;
  displayName: string;
}

export interface InvoiceSearchResult {
  _id: string;
  invoiceNumber: string;
  patientName: string;
  amount: number;
  status: string;
  date: string;
}

export interface AppointmentSearchResult {
  _id: string;
  patientName: string;
  doctorName: string;
  date: string;
  time: string;
  status: string;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  private readonly http = inject(HttpClient);

  private unwrap<T>(res: any): T[] {
    if (Array.isArray(res)) return res;
    if (res && Array.isArray(res.data)) return res.data;
    return [];
  }

  searchPatients(query: string): Promise<PatientSearchResult[]> {
    if (!query || query.length < 2) return Promise.resolve([]);
    return this.http.get<any>(
      `${environment.apiUrl}/patients`,
      { params: { search: query, limit: 5 } }
    ).toPromise().then(res => this.unwrap<PatientSearchResult>(res)).catch(() => []);
  }

  searchInvoices(query: string): Promise<InvoiceSearchResult[]> {
    if (!query || query.length < 2) return Promise.resolve([]);
    return this.http.get<any>(
      `${environment.apiUrl}/billing/invoices`,
      { params: { search: query, limit: 5 } }
    ).toPromise().then(res => this.unwrap<InvoiceSearchResult>(res)).catch(() => []);
  }

  searchAppointments(query: string): Promise<AppointmentSearchResult[]> {
    if (!query || query.length < 2) return Promise.resolve([]);
    return this.http.get<any>(
      `${environment.apiUrl}/appointments`,
      { params: { search: query, limit: 5 } }
    ).toPromise().then(res => this.unwrap<AppointmentSearchResult>(res)).catch(() => []);
  }
}
